module.exports = __webpack_public_path__ + "static/media/24UHCHR22.c4cbeec3.jpg";